import { IFetchAgendaWelcomeDataDTO } from 'modules/customer/domain/dtos';
import { IAgendaWelcomeRepository } from 'modules/customer/domain/repositories';

export class FetchAgendaWelcomeDataUseCase {
  constructor(private agendaWelcomeRepository: IAgendaWelcomeRepository) {}

  public async execute({
    customerId,
    unitId,
    flowType,
  }: IFetchAgendaWelcomeDataDTO) {
    return this.agendaWelcomeRepository.findOne({
      customerId,
      unitId,
      flowType,
    });
  }
}
